"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Functions;
(function (Functions) {
    Functions["TSCalculate"] = "TSCalculate";
})(Functions = exports.Functions || (exports.Functions = {}));
var TSCalculate = /** @class */ (function () {
    function TSCalculate() {
        this.name = Functions.TSCalculate;
        this.expression = function (sfo) { return "datasets['" + sfo.requestId + "'].value"; };
    }
    return TSCalculate;
}());
exports.TSCalculate = TSCalculate;
//# sourceMappingURL=functionList.js.map


// WEBPACK FOOTER //
// ./src/core/services/data/functionList.js